import React, { FC } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import {
  StyledButton,
  NavigationContainer,
  LogoContainer,
} from './SideNavigation.styles';
import {
  Box,
  IconName,
  MainMenuIcon,
  Tooltip,
  Typography,
} from '@prometheus/components';
import { Logo } from '../Logo/Logo';
import { BuildInfo } from '../BuildInfo/BuildInfo';
import { transparentize } from 'polished';

interface SideNavigationProps {
  list: any[];
  enabledModuleIds: string[];
}

export const SideNavigation: FC<SideNavigationProps> = props => {
  const { list, enabledModuleIds } = props;
  const navigate = useNavigate();
  const location = useLocation();

  const isActive = React.useCallback(
    (path?: string) => location.pathname.split('/')[1] === path,
    [location]
  );
  return (
    <NavigationContainer>
      <LogoContainer to="/">
        <Logo />
      </LogoContainer>

      {list?.map((item: any) => {
        return (
          enabledModuleIds.includes(item.name) && (
            <Tooltip
              placement="right"
              text={item.title || ''}
              key={item.name}
              show
            >
              <div>
                <StyledButton to={item.path || ''}>
                  <Box
                    className="icon-wrapper"
                    sx={theme => ({
                      padding: 1,
                      borderRadius: 1,
                      ...(isActive(item.path)
                        ? {
                            backgroundColor: transparentize(
                              0.85,
                              theme.palette.info.main
                            ),
                          }
                        : {}),
                    })}
                  >
                    <MainMenuIcon
                      iconName={item.iconName as IconName}
                      sx={{ fontSize: 28 }}
                    />
                  </Box>
                  <Typography
                    fontSize={10}
                    sx={{
                      width: '100%',
                      color: '#40527F',
                    }}
                    fontWeight={400}
                    // mt={0.5}
                  >
                    {item.title}
                  </Typography>
                </StyledButton>
              </div>
            </Tooltip>
          )
        );
      })}
      <BuildInfo />
    </NavigationContainer>
  );
};
